var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index_width"},[_c('div',{staticClass:"index_grid"},[_c('div',{staticClass:"grid_list"},_vm._l((_vm.gridList),function(item,index){return _c('div',{key:index,staticClass:"grid_item"},[_c('img',{attrs:{"src":item.imgUrl,"alt":""}}),_c('div',{staticClass:"grid_item_title"},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }